import React from 'react';
import { Button } from 'reactstrap';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { TextInput } from './FormElements';

const Forgot = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('enter a valid email address')
      .required('Email is required'),
  }),
  handleSubmit: async (payload, { props, setSubmitting, setErrors }) => {
    try {
      const errors = await props.handleSubmit(payload);
      setSubmitting(false);
      if (errors) {
        setErrors(errors);
      }
    } catch (e) {
      throw e;
    }
  },
  displayName: 'ForgotForm',
});

const forgotForm = (props) => {
  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props;

  return (
    <form onSubmit={handleSubmit} className='login-form'>
      <TextInput
        id='email'
        type='text'
        label={props.userNameLabel}
        labelClassName='sr-only'
        placeholder={props.userNameLabel}
        error={touched.email && errors.email}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Button
        type='submit'
        color='primary'
        disabled={!props.isValid || isSubmitting}
      >
        Forgot
      </Button>
      <div>
        <Link to='/'>Login</Link>
      </div>
      {isSubmitting && <div className='loader'>Loading...</div>}
    </form>
  );
};

export const ForgotForm = Forgot(forgotForm);
